var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"id":"XMLID_315_","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM8,7.8","key":0}),React.createElement("g",{"key":1},[React.createElement("ellipse",{"id":"XMLID_118_","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"7.9","rx":"4","ry":"4","key":0}),React.createElement("path",{"id":"XMLID_117_","fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeMiterlimit":"10","d":"M1.2,11\n\t\t\tC0.9,10.1,0.5,9.1,0.5,8c0-4.2,3.4-7.7,7.5-7.7s7.5,3.4,7.5,7.7c0,1-0.3,2.1-0.7,2.9","key":1}),React.createElement("path",{"id":"XMLID_103_","fill":"currentColor","d":"M15.2,15.1c0,0,0.4-3.3-1.2-3.3h-1.4c-0.6,0-0.7,0.3-0.8,0.4c-0.5,1-1.6,1.5-2.7,1.5H6.9\n\t\t\tc-1.1,0-2.3-0.5-2.7-1.5c-0.1-0.1-0.2-0.4-0.8-0.4H2.1c-1.6,0-1.2,3.3-1.2,3.3s1.3,0.8,7.2,0.8S15.2,15.1,15.2,15.1z","key":2})])]));
}

User.displayName = "User";

User.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = User;

User.default = User;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/user.svg
// module id = ../icon/src/icons/user.svg
// module chunks = 0